/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Subtract_Frame_From_StartInputs */

const en_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract 1 Frame From Start`)
};

const fr_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire 1 image au debut`)
};

const de_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe 1 Frame vom Start ab`)
};

const it_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai 1 fotogramma dall'inizio`)
};

const ru_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычтите 1 кадр из начального значения.`)
};

const es_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restar 1 fotograma del inicio`)
};

const zh_cn2_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从起始帧减去 1 帧`)
};

const ja_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始から1フレーム減算`)
};

const hi_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत से 1 फ्रेम घटाएँ`)
};

const pt_pt2_shortcut_keys_name_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia 1 quadro do início.`)
};

/**
* | output |
* | --- |
* | "Subtract 1 Frame From Start" |
*
* @param {Shortcut_Keys_Name_Subtract_Frame_From_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_subtract_frame_from_start = /** @type {((inputs?: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Subtract_Frame_From_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "de") return de_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "it") return it_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "es") return es_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_subtract_frame_from_start(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_subtract_frame_from_start(inputs)
	return en_shortcut_keys_name_subtract_frame_from_start(inputs)
});